import React, { useState, useEffect } from "react";
import DashboardNav from "../DashboardNavbar/DashboardNav";
import upload2 from "../../assets/img/upload2.png";
import add_icon from "../../assets/img/add_icon.png";
import Avatar from "@mui/material/Avatar";
import Modal from "@mui/material/Modal";
import Skeleton from "@mui/material/Skeleton";
import cross from "../../assets/img/cross.png";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TablePagination,
  Paper,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import UniversalModal from "../../components/modal/UniversalModal";
import UpdateModal from "../../components/modal/UpdateModal";
import DataTable from "react-data-table-component";
import { getAllProducts } from "../../api/Api";
import {
  addProduct,
  deleteProduct,
  getFCMToken,
  sendNotification,
} from "../../api/Api";
import SendAlertsModal from "../../components/modal/SendAlertsModal";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: 24,
};
const ProductDashboard = () => {
  const theme = useTheme();
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState(false);

  // Loading state
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  //delete product states
  const [deletingProductCode, setDeletingProductCode] = useState(null);

  //add product state starts
  const [itemName, setItemName] = useState("");
  const [brandName, setBrandName] = useState("");
  const [itemPrice, setItemPrice] = useState("");
  const [itemQuantity, setItemQuantity] = useState("");
  const [itemDetails, setItemDetails] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [productCode, setProductCode] = useState("");

  //add product state ends
  const [isUniversalModalOpen, setisUniversalModalOpen] = useState(false);
  const [productData, setProductData] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [refreshProducts, setRefreshProducts] = useState(false);
  const [totalStocks, setTotalStocks] = useState(0);
  const [totalSoldUnits, setTotalSoldUnits] = useState(0);

  //modal message state
  const [info, setInfo] = useState("");
  const [modalData, setModalData] = useState({
    header: "",
    body: "",
  });

  //pagination states
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getAllProducts();
        const products = response.data.products || [];
        setProductData(products);
        setTotalProducts(response.data.totalNoofProducts);

        // Calculate total stocks
        const totalStockCount = products.reduce(
          (acc, product) => acc + product.stock,
          0
        );
        setTotalStocks(totalStockCount);

        // Calculate total sold units
        const totalSoldUnitsCount = products.reduce(
          (acc, product) => acc + product.soldUnits,
          0
        );
        setTotalSoldUnits(totalSoldUnitsCount);

        // Set loading to false when data is fetched
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching products:", error);
        setIsLoading(false); // Even on error, set loading to false
      }
    };

    fetchProducts();
  }, [refreshProducts]);

  const handleUpdate = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleDelete = async (item) => {
    console.log("Initiating delete for:", item); // This should now log the full product object
    setIsDeleting(true);
    setDeletingProductCode(item.productCode); // Set productCode correctly
    try {
      console.log("Deleting product code:", item.productCode);
      await deleteProduct(item.productCode); // Ensure the delete function uses the correct identifier
      setRefreshProducts((prev) => !prev);
      setInfo("Product Deleted successfully");
      setisUniversalModalOpen(true);
    } catch (error) {
      console.error("Failed to delete product:", error);
    } finally {
      setDeletingProductCode(null); // Reset after deletion
      setIsDeleting(false);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };
  // Handle the form submit from UpdateModal
  const handleUpdateSubmit = () => {
    setRefreshProducts((prev) => !prev);
    setInfo("updated succesfully");
    setisUniversalModalOpen(true);
    setModalOpen(false);
  };
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleProductAdd = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    // Create a product object based on your state
    const productData = {
      name: itemName,
      description: itemDetails,
      brand: brandName,
      price: itemPrice,
      productCode: productCode,
    };

    try {
      // Send a request to your backend API
      const response = await addProduct(productData);
      if (response.data.success) {
        console.log("Product added successfully:", response.data.success);
        setInfo("Product added successfully");
        setisUniversalModalOpen(true);

        // Clear all input fields after success
        setItemName("");
        setBrandName("");
        setItemPrice("");
        setItemQuantity("");
        setItemDetails("");
        setProductCode("");
      } else {
        console.error("Error adding product:", response.message);
      }
    } catch (error) {
      console.error("Error during product submission:", error.message);
    } finally {
      setIsSubmitting(false);
      setOpen(false); // Close the modal
      setRefreshProducts((prev) => !prev);

      // Process notifications after modal has closed
      const userData = JSON.parse(localStorage.getItem("user_data"));
      if (userData && Array.isArray(userData)) {
        Promise.all(
          userData.map((user) => sendPushNotificationtoUser(user._id))
        )
          .then(() => {
            console.log("All notifications sent successfully!");
          })
          .catch((error) => {
            console.error("Error sending notifications:", error);
          });
      } else {
        console.warn("No valid user data found in local storage");
      }
    }
  };
  // Function to send push notifications
  const sendPushNotificationtoUser = async (userId) => {
    try {
      // Fetch the FCM token for the user
      const response = await getFCMToken({ id: userId });

      if (response?.data?.fcmToken) {
        console.log("FCM Token fetched:", response.data.fcmToken);

        // Send a notification using the fetched FCM token
        const notificationResponse = await sendNotification({
          fcmToken: response.data.fcmToken,
          title: "🎉 Exciting 🤩! ",
          body: `✨ A brand new product "${itemName}" added to Drips water is now available! Don't miss out! 🚀`,
          id: "",
          item: "",
        });

        if (notificationResponse?.data?.success) {
          console.log(
            "Push notification sent successfully:",
            notificationResponse.data
          );
        } else {
          console.error(
            "Failed to send push notification:",
            notificationResponse.data
          );
        }
      } else {
        console.error("Having trouble fetching FCM token");
      }
    } catch (error) {
      console.error("Error in sending push notification", error);
    }
  };

  const handleUniversalModal = () => {
    setisUniversalModalOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset to the first page
  };

  // ------------------
   // Function to handle modal open
   const handleOpenModal = () => {
    setIsAlertModalOpen(true);
  };

  // Function to handle modal close
  const handleCloseModal2 = () => {
    setIsAlertModalOpen(false);
    setModalData({ header: "", body: "" }); // Reset modal data
  };

  // Function to handle data submission
  const handleModalSubmit = () => {
    console.log("Modal Data Submitted:", modalData);
    alert(`Header: ${modalData.header}, Body: ${modalData.body}`);
    handleCloseModal(); // Close modal after submission
  };

  // Slice data for the current page
  const paginatedData = productData.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );
  const truncateText = (text, charLimit) => {
    if (!text) return "";
    if (text.length > charLimit) {
      return text.slice(0, charLimit) + " .....";
    }
    return text;
  };

  return (
    <Box sx={{ height: "100vh" }}>
      {/* Navbar */}
      <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000 }}>
        <DashboardNav />
      </Box>

      {/* Main content */}
      <Box
        sx={{
          position: "absolute",
          top: "180px",
          left: 0,
          right: 0,
          px: 1,
          width: "90vw",
          margin: "auto",
          color: "#888585",
          fontFamily: theme.palette.typography,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontSize: "32px", lineHeight: "34.85px", fontWeight: "500" }}
          gutterBottom
        >
          Prodcuts
        </Typography>

        {/* Product Cards */}
        <Grid container spacing={1}>
          {/* Card 1 */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                background: "linear-gradient(180deg, #EA4245 0%, #F5FFFB 100%)",
                borderRadius: "10px",
                color: "#F5F5F5",
                width: "80%",
                padding: "30px",
                boxShadow: "0px 4px 4px 0px #E59292",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100px",
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontWeight: "500",
                    fontSize: "24px",
                    color: "#F5F5F5",
                  }}
                >
                  Total no of Products
                </Typography>
                {isLoading ? (
                  <Skeleton variant="circular" width={56} height={56} />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor: "#CE1B1E",
                      color: "#F5F5F5",
                      width: 70,
                      height: 70,
                      fontSize: "24px",
                    }}
                  >
                    {totalProducts}
                  </Avatar>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Card 2 */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                background: "linear-gradient(180deg, #1A6714 0%, #F5FFFB 100%)",
                borderRadius: "10px",
                color: "#F5F5F5",
                width: "80%",
                padding: "30px",
                boxShadow: "0px 4px 4px 0px #9AEFB6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100px",
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontWeight: "500",
                    fontSize: "24px",
                    color: "#F5F5F5",
                  }}
                >
                  Total Available Stock
                </Typography>
                {isLoading ? (
                  <Skeleton variant="circular" width={56} height={56} />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor: "#1A6714",
                      color: "#F5F5F5",
                      width: 70,
                      height: 70,
                      fontSize: "24px",
                    }}
                  >
                    {totalStocks}
                  </Avatar>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Card 3 */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                background: "linear-gradient(180deg, #4030D2 0%, #F5FFFB 100%)",
                borderRadius: "10px",
                color: "#F5F5F5",
                width: "80%",
                padding: "30px",
                boxShadow: "0px 4px 4px 0px #DFD8FF",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100px",
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontWeight: "500",
                    fontSize: "24px",
                    color: "#F5F5F5",
                  }}
                >
                  Total Units Sold
                </Typography>
                {isLoading ? (
                  <Skeleton variant="circular" width={56} height={56} />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor: "#3D2C8B",
                      color: "#F5F5F5",
                      width: 70,
                      height: 70,
                      fontSize: "24px",
                    }}
                  >
                    {totalSoldUnits}
                  </Avatar>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {/* Customer Details */}
        <Box sx={{ mt: 4, color: "#888585" }}>
          {/* Row with Product Details and Buttons */}
          <Grid
            container
            spacing={2}
            sx={{
              mb: 2,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* Product Details text */}
            <Grid item>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "500",
                  fontSize: "32px",
                  lineHeight: "34.85px",
                }}
                gutterBottom
              >
                Product Details
              </Typography>
            </Grid>

            {/* Buttons container */}
            <Grid
              item
              sx={{
                display: "flex",
                gap: 2, // Adds spacing between buttons
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={handleOpen}
                variant="contained"
                sx={{
                  backgroundColor: theme.palette.primary.light,
                  color: "#fff",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "#2E7D32",
                  },
                }}
                startIcon={
                  <img
                    src={add_icon}
                    alt="Add"
                    style={{
                      width: "28px",
                      height: "28px",
                      objectFit: "contain",
                    }}
                  />
                }
              >
                Add items
              </Button>
              <Button
                 onClick={handleOpenModal}
                variant="contained"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: "#fff",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "#2E7D32",
                  },
                }}
              >
                Send Alerts
              </Button>
            </Grid>
          </Grid>

          {/* User Details Table */}
          {isLoading ? (
            <TableContainer sx={{ mt: 4 }} component={Paper}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor:theme.palette.primary.light, p: 6 }}>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      SL No.
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Code
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Name
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Description
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Price
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Available
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Items Sold
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array(5)
                    .fill()
                    .map((_, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          <Skeleton
                            variant="rectangular"
                            width={40}
                            height={30}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Skeleton
                            variant="rectangular"
                            width={80}
                            height={30}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Skeleton
                            variant="rectangular"
                            width={120}
                            height={30}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Skeleton
                            variant="rectangular"
                            width={150}
                            height={30}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Skeleton
                            variant="rectangular"
                            width={80}
                            height={30}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Skeleton
                            variant="rectangular"
                            width={80}
                            height={30}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Skeleton
                            variant="rectangular"
                            width={80}
                            height={30}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Skeleton
                            variant="rectangular"
                            width={100}
                            height={30}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <TableContainer sx={{ mt: 4 }} component={Paper}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor:theme.palette.primary.light, p: 6 }}>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      SL No.
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Code
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Name
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Description
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Price
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Item Available
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Items Sold
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }} align="center">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[...paginatedData]
                    .reverse() // Reverse the array
                    .map((product, index) => (
                      <TableRow key={product._id}>
                        <TableCell align="center">
                          {currentPage * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell align="center">
                          {product.productCode}
                        </TableCell>
                        <TableCell align="center">{product.brand}</TableCell>
                        <TableCell align="center">
                          {truncateText(product.description, 100)}
                        </TableCell>
                        <TableCell align="center">{product.price}</TableCell>
                        <TableCell align="center">{product.stock}</TableCell>
                        <TableCell align="center">
                          {product.soldUnits}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            onClick={() => handleUpdate(product)}
                            sx={{
                              mr: 1,
                              textTransform: "capitalize",
                              backgroundColor: "#FF893A",
                              color: "#fff",
                              "&:hover": { backgroundColor: "#1976D2" },
                            }}
                          >
                            Update
                          </Button>
                          <Button
                            variant="contained"
                            onClick={() => handleDelete(product)}
                            disabled={
                              isDeleting &&
                              deletingProductCode === product.productCode
                            }
                            sx={{
                              backgroundColor: "#EA4245",
                              color: "#fff",
                              textTransform: "capitalize",
                              "&:hover": { backgroundColor: "#D32F2F" },
                            }}
                          >
                            {isDeleting &&
                            deletingProductCode === product.productCode
                              ? "Please wait..."
                              : "Delete"}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={productData.length}
                page={currentPage}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          )}

          {/* Update Modal */}
          {selectedItem && (
            <UpdateModal
              open={isModalOpen}
              handleClose={handleCloseModal}
              initialData={selectedItem} // Pass the selected item data to the modal
              onSubmit={handleUpdateSubmit} // Handle the submit of updated data
            />
          )}
        </Box>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="add-item-modal-title"
        aria-describedby="add-item-modal-description"
      >
        <Box sx={style} component="form" onSubmit={handleProductAdd}>
          {/* Modal Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: "20px",
              color: "#fff",
              position: "relative",
              display: "flex",
              justifyContent: "space-between",
              // width:'100%'
            }}
          >
            <Typography id="add-item-modal-title" variant="h6" component="h2">
              Add Items Details
            </Typography>
            {/* Close Icon */}
            <Box
              component="img"
              src={cross}
              alt="Close"
              sx={{
                width: "30px",
                height: "30px",
                cursor: "pointer",
              }}
              onClick={handleClose} // Closes the modal when clicked
            />
          </Box>

          {/* Modal Body */}
          <Box sx={{ padding: "20px" }}>
            <Grid container spacing={2}>
              {/* Left Section with Form Fields */}
              <Grid item xs={8}>
                <Grid container spacing={2}>
                  {/* Item Name and Brand Name in one row */}
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Item Name"
                      value={itemName}
                      onChange={(e) => setItemName(e.target.value)}
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Brand Name"
                      value={brandName}
                      onChange={(e) => setBrandName(e.target.value)}
                      variant="outlined"
                      required
                    />
                  </Grid>

                  {/* Item Price and Item Available Quantity in one row */}
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Item Price"
                      value={itemPrice}
                      onChange={(e) => setItemPrice(e.target.value)}
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Item Code"
                      value={productCode}
                      onChange={(e) => setProductCode(e.target.value)}
                      variant="outlined"
                      required
                    />
                  </Grid>

                  {/* Item Details in a single row */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      label="Item Details"
                      value={itemDetails}
                      onChange={(e) => setItemDetails(e.target.value)}
                      variant="outlined"
                      required
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Right Section with Upload Button and Save Button */}
              <Grid item xs={4}>
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  spacing={2}
                >
                  {/* Upload Section */}
                  <Grid item>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Upload Item Photo
                    </Typography>
                    {/* Label for the upload button */}
                    <Button
                      variant="contained"
                      component="label"
                      sx={{
                        width: "150px",
                        height: "140px",
                        padding: "16px",
                        border: "1px dashed #CCCCCC",
                        backgroundColor: "#F5F5F5",
                        borderRadius: "15px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        color: "#000",
                        "&:hover": {
                          backgroundColor: "#E0E0E0",
                        },
                        opacity: 0.5, // Reduce opacity to make it appear disabled
                        pointerEvents: "none", // Prevent clicks
                      }}
                      disabled // This disables the button
                    >
                      <img
                        src={upload2}
                        alt=""
                        style={{
                          height: "35px",
                          width: "35px",
                          padding: "5px",
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#000",
                          textAlign: "center",
                          fontSize: "15px",
                          textTransform: "capitalize",
                        }}
                      >
                        Upload Photo
                      </Typography>
                      <input type="file" hidden />
                    </Button>
                    <Typography
                      sx={{
                        color: "#FF1744",
                        mt: 1,
                        textAlign: "left",
                        fontSize: "13px",
                      }}
                    >
                      Image must be in .png, .jpg format and max width of 1080px
                    </Typography>
                  </Grid>

                  {/* Save Button */}
                  <Grid
                    sx={{
                      marginLeft: "10vw",
                      paddingTop: "1rem",
                      width: "10vw",
                    }}
                    item
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      sx={{
                        width: "100%",
                        height: "50%",
                        padding: "0.8rem",
                        backgroundColor:theme.palette.primary.light,
                      }}
                    >
                      {isSubmitting ? "Saving..." : "Save Data"}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
      <UniversalModal
        open={isUniversalModalOpen}
        onClose={handleUniversalModal}
        message={info}
      />
      <SendAlertsModal
        open={isAlertModalOpen}
        handleClose={handleCloseModal2}
        onSubmit={handleModalSubmit}
      />
    </Box>
  );
};

export default ProductDashboard;
